<ix-layout-step
  [description]="helptext.dedup_vdev_description | translate"
  [type]="VdevType.Dedup"
  [inventory]="inventory$ | async"
  [canChangeLayout]="canChangeLayout"
  [limitLayouts]="allowedLayouts"
  [isStepActive]="isStepActive"
></ix-layout-step>

<p *ngIf="stepWarning" class="warning">
  {{ stepWarning }}
</p>

<ix-form-actions>
  <button
    mat-button
    matStepperPrevious
    color="accent"
    type="button"
    ixTest="back-dedup"
  >
    {{ 'Back' | translate }}
  </button>
  <button
    mat-button
    matStepperNext
    color="primary"
    type="button"
    ixTest="next-dedup"
  >
    {{ 'Next' | translate }}
  </button>

  <button
    mat-button
    color="error"
    type="button"
    ixTest="reset-fields-in-dedup-step"
    (click)="resetStep()"
  >
    {{ 'Reset Step' | translate }}
  </button>

  <button
    mat-button
    color="accent"
    type="button"
    ixTest="save-and-go-to-review-dedup"
    (click)="goToReviewStep()"
  >
    {{ 'Save And Go To Review' | translate }}
  </button>
</ix-form-actions>

